import React, { useState, useEffect } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { RadioGroup, Radio, FormControlLabel } from '@material-ui/core';
import HttpService from '../services/httpService';
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
	table: {
		minWidth: 850,
	},
}));

const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: "#ccc",
		color: theme.palette.common.black,
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
	root: {
		'&:nth-of-type(odd)': {
			backgroundColor: theme.palette.action.hover,
		},
	},
}))(TableRow);

// Read-only: shows only the requests the logged-in user themselves raised, with no
// Approve/Reject actions — this is a personal history view, not an approval queue.
const AdhocHistoryModal = (props) => {
	const classes = useStyles();

	const [history, setHistory] = useState([])
	const [totalApprovedAdhocValue, setTotalApprovedAdhocValue] = useState(0)
	const [type, setType] = useState('ALL')

	useEffect(() => {
		getHistory()
		// eslint-disable-next-line
	}, [props.SELECTEDPROJECT])

	const getHistory = async () => {
		props.setLoading(true)
		try {
			const result = await HttpService.getAdhocHistory(props.SELECTEDPROJECT._id)
			setHistory(result.data.data)
			setTotalApprovedAdhocValue(result.data.totalApprovedAdhocValue)
		} catch (error) {
			console.error(error)
			props.setSnackInfo("Couldn't fetch Ad-hoc history", "error")
		}
		props.setLoading(false)
	}

	const filteredHistory = type === 'ALL' ? history : history.filter(tx => tx.type === type)

	return (
		<div style={{ textAlign: "left" }}>
			<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", marginBottom: 15 }}>
				<span><b>Total Approved Ad-hoc Value: </b>₹{totalApprovedAdhocValue}</span>
				<RadioGroup row value={type} onChange={(e) => setType(e.target.value)}>
					<FormControlLabel value="ALL" control={<Radio color="primary" />} label="All" />
					<FormControlLabel value="PO" control={<Radio color="primary" />} label="Ad-hoc PO" />
					<FormControlLabel value="SO" control={<Radio color="primary" />} label="Ad-hoc SO" />
				</RadioGroup>
			</div>
			<TableContainer component={Paper}>
				<Table className={classes.table} size="small" aria-label="customized table">
					<TableHead>
						<TableRow>
							<StyledTableCell>PO/SO Number</StyledTableCell>
							<StyledTableCell>Type</StyledTableCell>
							<StyledTableCell>Amount</StyledTableCell>
							<StyledTableCell>Status</StyledTableCell>
							<StyledTableCell>Created By</StyledTableCell>
							<StyledTableCell>Approval Steps</StyledTableCell>
							<StyledTableCell>Created Date</StyledTableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{filteredHistory.map((tx, i) => (
							<StyledTableRow key={i}>
								<StyledTableCell>{tx.orderNumber || 'Pending'}</StyledTableCell>
								<StyledTableCell>{tx.type}</StyledTableCell>
								<StyledTableCell>{tx.amount}</StyledTableCell>
								<StyledTableCell>{tx.status}</StyledTableCell>
								<StyledTableCell>{tx.createdBy}</StyledTableCell>
								<StyledTableCell>
									{tx.approvalSteps?.map((step, j) => (
										<div key={j} style={{ marginBottom: 4 }}>
											<b>{step.role}</b>: {step.status}
											{step.approverName && ` by ${step.approverName}`}
											{step.decisionDate && ` (${moment(step.decisionDate).format('DD-MM-YYYY')})`}
											{step.remark && <div>Remark: {step.remark}</div>}
										</div>
									))}
								</StyledTableCell>
								<StyledTableCell>{moment(tx.createdDate).format('DD-MM-YYYY hh:mm A')}</StyledTableCell>
							</StyledTableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	)
}

export default connect(null, { setLoading, setSnackInfo })(AdhocHistoryModal)
